import React from "react";

const Section11Indemnification = () => (
  <>
    <h2>11. Indemnification</h2>
    <p>
    You agree to indemnify, defend, and hold harmless Comparedly Ltd., its affiliates, officers, directors, employees, agents, suppliers, and licensors from and against any and all claims, damages, losses, liabilities, and expenses (including reasonable attorneys' fees) arising out of or relating to: (a) your use of the Service; (b) your violation of these Terms; (c) your violation of any applicable law or regulation; (d) your Content; or (e) your infringement of any third-party rights. Comparedly Ltd. reserves the right to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will cooperate with Comparedly Ltd. in asserting any available defenses.
    </p>

  </>
);

export default Section11Indemnification;
